import { useLocalization } from '@magicdoorinc/ui';
import { createEffect, createResource, createSignal } from 'solid-js';
import { createMagicDoorContext } from '~/contexts/utils';
import { featureHighlightsRepo } from '~/repositories/featureHighlightsRepository';

export const [FeatureHighlightsProvider, useFeatureHighlights] = createMagicDoorContext('FeatureHighlights', () => {
  const { currentLanguage } = useLocalization();
  const [highlights] = createResource(currentLanguage, (language) => featureHighlightsRepo.getActiveFeatureHighlights(language));

  const [pulse, setPulse] = createSignal(false);
  let hasPulsed = false;
  createEffect(() => {
    if (!hasPulsed && (highlights()?.items?.length ?? 0) > 0) {
      hasPulsed = true;
      setPulse(true);
      setTimeout(() => setPulse(false), 3200);
    }
  });

  return {
    highlights,
    pulse,
  };
});
